import { NavbarVerticalItem } from '@siemens/element-ng/navbar-vertical';
import { environment } from '../../environments/environment';

export const NAVBAR_VERTICAL_ITEMS: NavbarVerticalItem[] = [
    {
        type: 'router-link',
        label: 'nav.management.home',
        icon: 'element-home',
        routerLink: '/home'
    },
    {
        type: 'router-link',
        label: 'nav.management.application-processing',
        icon: 'element-registration',
        routerLink: '/applications'
    },
    {
        type: 'router-link',
        label: 'nav.management.deadlines',
        icon: 'element-booking-overview',
        routerLink: '/deadlines'
    },
    {
        type: 'link',
        label: 'nav.management.user-management',
        icon: 'element-user-group-alt',
        href: environment.userManagementUrl,
        target: '_blank'
    }
];
